module.exports = __webpack_public_path__ + "static/media/github.1d6e41e9.svg";